module.exports = __webpack_public_path__ + "static/media/notification_icon_success.db0220a4.svg";